import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollOption extends Component {
  view() {
    const {
      option,
      state
    } = this.attrs;
    const voted = state.hasVotedFor(option);
    const bar = m("label", {
      className: "PollBar",
      "data-selected": voted || undefined,
      style: `--poll-option-width: ${this.width()}%`
    }, this.barItems().toArray());
    const className = classList('PollOption', voted && 'PollOption--voted', option.imageUrl() && 'PollOption--hasImage');
    if (!state.canSeeVoteCount) {
      return m("div", {
        className: className,
        "data-id": option.id()
      }, bar);
    }
    return m(Tooltip, {
      text: app.translator.trans('fof-polls.forum.tooltip.votes', {
        count: option.voteCount()
      })
    }, m("div", {
      className: className,
      "data-id": option.id()
    }, bar));
  }
  barItems() {
    const items = new ItemList();
    const {
      option,
      name,
      state
    } = this.attrs;
    const multiple = state.poll.allowMultipleVotes();
    items.add('input', m("input", {
      className: "PollOption-input",
      type: multiple ? 'checkbox' : 'radio',
      name: name,
      value: option.id(),
      checked: state.hasVotedFor(option),
      disabled: !state.canSelect()
      // A selected radio fires no change event when clicked again, so the
      // click is the only signal to withdraw. A checkbox flips, so it is
      // left to change alone.
      ,
      onclick: e => {
        if (!multiple && state.hasVotedFor(option)) state.changeVote(option, e);
      },
      onchange: e => state.changeVote(option, e)
    }), 100);
    items.add('text', m("span", {
      className: "PollOption-text"
    }, this.textItems().toArray()), 50);
    if (option.imageUrl()) {
      items.add('image', m("img", {
        className: "PollOption-image",
        src: option.imageUrl(),
        srcset: option.imageSrcset() ?? undefined,
        alt: option.answer(),
        loading: "lazy"
      }), 0);
    }
    return items;
  }
  textItems() {
    const items = new ItemList();
    const {
      option,
      state
    } = this.attrs;
    items.add('answer', m("span", {
      className: "PollOption-answer"
    }, option.answer()), 100);
    if (state.canSeeVoteCount) {
      const percent = this.percent();
      items.add('percent', m("span", {
        className: classList('PollOption-percent', percent === 100 && 'PollOption-percent--full')
      }, percent, "%"), 50);
      items.add('votes', m("span", {
        className: "sr-only"
      }, app.translator.trans('fof-polls.forum.tooltip.votes', {
        count: option.voteCount()
      })), 0);
    }
    return items;
  }
  percent() {
    const total = this.attrs.state.overallVoteCount();
    return total > 0 ? Math.round(this.attrs.option.voteCount() / total * 100) : 0;
  }

  // With no count to scale against, the bar just marks what the reader picked.
  width() {
    const state = this.attrs.state;
    if (state.canSeeVoteCount) return this.percent();
    return Number(state.hasVotedFor(this.attrs.option)) / (state.poll.myVotes()?.length || 1) * 100;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollOption', PollOption);